import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams } from '../CustomUtils'
import { MONTHLY_COUNT_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const MONTHLY_COUNT_REPORT = gql(MONTHLY_COUNT_REPORT_QUERY)

export default function MonthlyCountReport({ location }) {
  console.log('MonthlyCountReport rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, MONTHLY_COUNT_REPORT, 'monthlyCountReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/BosSci/monthlyCountReport/monthly_count.csv?inputs=${JSON.stringify(inputs)}`
    const totalColumns = [
      { columnNumber: 2, formatter: new Intl.NumberFormat().format },
      { columnNumber: 3, formatter: new Intl.NumberFormat().format },
    ]
    const columnFormatters = [
      { columnNumber: 2, formatter: new Intl.NumberFormat().format, align: 'right' },
      { columnNumber: 3, formatter: new Intl.NumberFormat().format, align: 'right' },
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '900px', margin: 'auto'}} >
          <ReportHeading title='Monthly Count Report' parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} />
          </tbody>
        </Table>
      </div>
    )
  }
}